import { render } from "./deal-item.vue?vue&type=template&id=9c23fe68&scoped=true"
import script from "./deal-item.vue?vue&type=script&lang=js"
export * from "./deal-item.vue?vue&type=script&lang=js"

import "./deal-item.vue?vue&type=style&index=0&id=9c23fe68&scoped=true&lang=scss"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c23fe68"]])

export default __exports__